<template>
  <div class="homepage_wrap">
    <routerCom btnIndex="3" :changePop="changePop"/>
    <div class="imgArr">
      <img style="margin-top: -6px;" src="../assets/img/we/titleBg.png" alt="" />
      <div class="app" v-if="isShow">
        <div class="app-item" :style="{height:'96px'}">
          <div class="text-email">
            <img src="../assets/img/we/email.png" alt="" />
            招聘邮箱：zhongkezhilian@yeah.net ｜请将简历发送至招聘邮箱并写明您要应聘的职位
          </div>
        </div>

        <div class="app-item">
          <div :style="{display: 'flex',margin:'50px 0 0 40px'}">
            <div class="line"></div>
            <div class="line-text">高级硬件开发工程师</div>
          </div>
          <div class="text">{{ local.province }} |  5-10年  |  本科</div>
          <div class="text">根据要求完成产品硬件设计；
            完成硬件元器件选型、辅助产品结构设计；
            设计各PCB板件原理图设计；
            负责硬件系统或单元的调试，并参与完成系统测试；
            负责产品新技术研发；
            负责产品培训和技术支持；
            负责产品升级和维护。</div>
        </div>

        <div class="app-item">
          <div :style="{display: 'flex',margin:'50px 0 0 40px'}">
            <div class="line"></div>
            <div class="line-text">协议开发工程师</div>
          </div>
          <div class="text">{{ local.province }} |  3-5年  |  本科</div>
          <div class="text">CAN总线硬件设计分析，熟悉常用CAN总线硬件电路原理图的设计、电路板的布局和制作，通过分析结合到产品中；
            CAN总线软件开发，负责CAN总线软件的开发、调试和维护，包括CAN通讯协议、CAN总线控制程序和设备驱动程序等；
            CAN总线故障分析和解决，负责CAN总线的故障分析和解决，包括硬件故障、软件故障和通讯故障等，保证CAN总线系统的稳定性和可靠性；
            CAN总线系统的文档编写:负责编写CAN总线系统的技术文档和用户手册，包括硬件原理图、软件流程图和用户指南等，方便用户进行操作和维护。</div>
        </div>

        <div class="app-item">
          <div :style="{display: 'flex',margin:'50px 0 0 40px'}">
            <div class="line"></div>
            <div class="line-text">java工程师</div>
          </div>
          <div class="text">{{ local.province }} |  1-3年  |  本科</div>
          <div class="text">负责产品服务端业务需求研发，能够独立负责业务模块；
            提供需求实现方案，业务和技术问题跟进和解决；
            对业务功能进行优化和重构；
            保证服务的高可用性，优化服务性能。</div>
        </div>

        <div class="app-item">
          <div :style="{display: 'flex',margin:'50px 0 0 40px'}">
            <div class="line"></div>
            <div class="line-text">Android开发工程师</div>
          </div>
          <div class="text">{{ local.province }} |  1-3年  |  本科</div>
          <div class="text">负责Android手机软件的开发及设计；
            根据产品的需求进行Android产品的分析；
            对Android平台开发技术进行研究，发现其缺陷并改正更新；
            根据用户需求研发新的Android产品，并测试其性能，进行改进；
            根据项目需求进行学习并快速掌握技巧；
            平常要与相关工作人员进行沟通，使团队快速成长起来。</div>
        </div>

      </div>
      <img src="../assets/img/home/infoBg.png" alt="" />
    </div>
  </div>
</template>

<script>
import routerCom from './routerCom.vue'
import { jsonp } from 'vue-jsonp'
export default {
  name: 'addWe',
  components:{
    routerCom,
  },
  props: {
    isPopShow:Function
  },
  data() {
    return {
      dzlist:["北京","天津","广州","上海"],
      isShow:false,
    // 当地信息（城市、时间、地点、天气）
    local: {
    // ip地址所在城市
    province: '',
    city: '',
    // 所在城市温度
    temperature: '',
    // 天气类型
    type: '',
    // 时
    hour: '',
    // 分
    minute: '',
    // 月
    month: '',
    // 日
    date: '',
    // 星期几
    day: '',
    // 出勤率echart数据
    },
  }},
  mounted(){
    //this.getLocalCity()
    this.local.province = "广州"
    this.isShow = true
  },
  methods: {
    changePop(isp){
      this.isPopShow(isp);
    },
    getLocalCity() {
      var data = {
        key: 'TWMBZ-K4WY7-6FMXH-HGJBV-BTB33-ELFHF', //申请的密钥,写死就行
      }

      var url = 'https://apis.map.qq.com/ws/location/v1/ip' //这个就是地理位置信息的接口

      data.output = 'jsonp'

      jsonp(url, data)
        .then((res) => {
          if(res.status == 0){
            this.local.province = res.result.ad_info.province
          }else{
            let r = Math.random() * (1 - 4) + 4;
            this.local.province = dzlist[r]
          }
          
          // 根据城市，获取当前天气和时间（在此先预留获取天气方法，完成后取消注释）
          // this.getLocalWeather(this.local.city)
          this.isShow = true;
      })
      .catch((error) => {
        console.log(error)
      })
    },
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.homepage_wrap {
	width: 1280px;
	margin: auto;
  text-align: center;
}

.app{
  margin: auto;
  text-align: center;
}

.app .app-item{
  width: 1200px;
  height: 220px;
  border-radius: 4px;
  border: 1px solid #E6E6E6;
  margin: 20px auto;
  // cursor: pointer;
}

.app .app-item .text{
  // width: 800px;
  display: flex;
  align-items: center;
}

.app .app-item img{
  margin:0 5px 0 40px;
}

.imgArr img{
  margin: 32px auto 0 auto;
  max-width: 1280px;
}

.text{
  text-align: left;
  margin: 20px 0 0 40px;
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #9E9E9E;
}

.text-email{
  text-align: left;
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 96px;
  color: #9E9E9E;

  display: flex;
  align-items: center;
}

.line{
  width: 6px;
  height: 20px;
  border-radius: 1px;
  background: #C53624;
}

.line-text{
  font-family: Noto Sans SC;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #131313;
  margin-left: 5px;
}

</style>
